import config from '@/config'
import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

// Layouts
import DefaultLayout from '@/layouts/Default'

// Pages
import Login from '@/views/common/Login'
import Register from '@/views/common/Register'
import PasswordForgot from '@/views/common/PasswordForgot'
import PasswordReset from '@/views/common/PasswordReset'
import Search from '@/views/common/Search'
import Contact from '@/views/common/Contact'

// Dashboards
import CustomerZone from '@/views/customer/CustomerZone'
import SalesmanZone from '@/views/salesman/SalesmanZone'
import AdminZone from '@/views/admin/AdminZone'

// PreOrders
import CustomerPreOrders from '@/views/customer/preOrders/index'
import SalesmanPreOrders from '@/views/salesman/preOrders/index'
import AdminPreOrders from '@/views/admin/preOrders/index'

// Admin specific
import AdminAccountUsers from '@/views/admin/account/Users'
import AdminAccountEditUser from '@/views/admin/account/EditUser'
import Notifications from '@/views/admin/notification/index'
import Banners from '@/views/admin/banners/index'
import Branches from '@/views/admin/branches/index'
import Coupons from '@/views/admin/coupons/index'
import Countries from '@/views/admin/countries/index'
import SizeCharts from '@/views/admin/sizeCharts/index'
import PreOrderReport from '@/views/admin/reports/PreOrderReport'

// Customer specific
import CustomerAccount from '@/views/customer/account/index'
import Shop from '@/views/customer/shop/index'
import Basket from '@/views/customer/basket/index'
import OurBrands from '@/views/customer/ourBrands/index'
import Downloads from '@/views/customer/downloads/index'

// Salesman specific
import CustomerList from '@/views/salesman/customerList/index'
import SalesmanAccount from '@/views/salesman/account/index'

//Common
import Warranty from '@/views/common/Warranty'

Vue.use(Router);

window.app = config;

const router = new Router({
    mode: 'history',
    base: window.app.config.locale,
    routes: [
        {
            path: '/login',
            component: Login
        },
        {
            path: '/register',
            component: Register,
            meta: { requiresAuth: false }
        },
        {
            path: '/password-forgot',
            component: PasswordForgot,
            meta: { requiresAuth: false }
        },
        {
            path: '/resetpassword',
            component: PasswordReset,
            meta: { requiresAuth: false }
        },
        {
            path: '/',
            component: DefaultLayout,
            meta: {requiresAuth: true},
            children: [

                // WARRANTY
                {
                    path:'/warranty',
                    component: Warranty,
                    meta: { requiresAuth: true}
                },

                // SEARCH
                {
                    path: '/search',
                    name: "Search",
                    component: Search,
                    meta: { requiresAuth: true }
                },

                // CONTACT
                {
                    path: '/contact',
                    name: "Contact",
                    component: Contact,
                    meta: { requiresAuth: true }
                },

                // CUSTOMER
                {
                    path: '/customer',
                    component: CustomerZone,
                    meta: {
                        requiresAuth: true,
                        customerAuth: true
                    }
                },
                {
                    path: '/customer/pre-orders',
                    component: CustomerPreOrders.Base,
                    meta: {
                        requiresAuth: true,
                        customerAuth: true
                    },
                    redirect: '/customer/pre-orders/overview',
                    children: [
                        {
                            path: 'overview',
                            component: CustomerPreOrders.Overview,
                            name: "CustomerPreOrdersOverview",
                            meta: {
                                breadcrumb: 'Overview'
                            },
                        },
                        {
                            path: 'edit/:id',
                            component: CustomerPreOrders.Edit,
                            name: "CustomerPreOrdersEdit",
                            meta: {
                                breadcrumb: 'Edit'
                            },
                            props: true
                        }
                    ]
                },
                {
                    path: '/customer/basket',
                    component: Basket.Base,
                    meta: {
                        requiresAuth: true,
                        customerAuth: true
                    },
                    redirect : '/customer/basket/overview',
                    children: [
                        {
                            path:'overview',
                            component: Basket.Overview,
                            name: "BasketOverview",
                            meta: {
                                breadcrumb: 'overview'
                            },
                        },
                        {
                            path:'checkout',
                            component: Basket.Checkout,
                            name: "BasketCheckout",
                            meta: {
                                breadcrumb: 'checkout'
                            },
                        },
                        {
                            path:'confirmation',
                            component: Basket.Confirmation,
                            name: "BasketConfirmation",
                            meta: {
                                breadcrumb: 'confirmation'
                            },
                        }
                    ]
                },
                {
                    path: '/customer/shop',
                    component: Shop.Base,
                    meta: {
                        requiresAuth: true,
                        customerAuth: true
                    },
                    redirect: '/customer/shop/overview',
                    children: [
                        {
                            path: 'overview',
                            component: Shop.Overview,
                            name: "ShopOverview",
                            meta: {
                                breadcrumb: 'overview'
                            },
                            props: true
                        },
                        {
                            path: 'product/:id',
                            component: Shop.Detail,
                            name: "ProductDetailview",
                            meta: {
                                breadcrumb: 'product'
                            },
                            props: true
                        },
                        {
                            path: 'fast-order',
                            component: Shop.FastOrder,
                            name: "FastOrder"
                        },
                    ]
                },
                {
                    path: '/customer/account',
                    component: CustomerAccount.Base,
                    redirect: '/customer/account/edit',
                    meta: {
                        breadcrumb: 'account',
                        requiresAuth: true,
                        customerAuth: true
                    },
                    children: [
                        {
                            path: 'edit',
                            component: CustomerAccount.Edit,
                            name: "CustomerAccountEdit",
                            meta: {
                                breadcrumb: 'edit'
                            },
                        },
                        {
                            path: 'users',
                            component: CustomerAccount.Users,
                            name: "CustomerAccountUsers",
                            meta: {
                                breadcrumb: 'users'
                            }
                        },
                        {
                            path: 'editUser',
                            component: CustomerAccount.EditUser,
                            name: "CustomerAccountEditUser",
                            meta: {
                                breadcrumb: 'edit'
                            }
                        },
                        {
                            path: 'addresses',
                            component: CustomerAccount.Addresses,
                            name: "CustomerAccountAddresses",
                            meta: {
                                breadcrumb: 'addresses'
                            },
                        },
                        {
                            path: 'addresses/create/:type',
                            component: CustomerAccount.AddressesCreate,
                            name: "CustomerAccountAddressesCreate"
                        },
                        {
                            path: 'history',
                            component: CustomerAccount.History,
                            name: "CustomerAccountHistory",
                            meta: {
                                breadcrumb: 'history'
                            },
                        },
                        {
                            path: 'history/detail/:id',
                            component: CustomerAccount.HistoryDetail,
                            name: "CustomerAccountHistoryDetail",
                            meta: {
                                breadcrumb: 'history_detail'
                            },
                            props: true
                        },
                        {
                            path: 'backorders',
                            component: CustomerAccount.Backorders,
                            name: "CustomerAccountBackorders",
                            meta: {
                                breadcrumb: 'backorders'
                            },
                        },
                        {
                            path: 'backorders/detail/:id',
                            component: CustomerAccount.HistoryDetail,
                            name: "CustomerAccountBackordersDetail",
                            meta: {
                                breadcrumb: 'backorders_detail'
                            },
                            props:true
                        },
                        {
                          path: 'invoices',
                          component: CustomerAccount.Invoices,
                          name: "CustomerAccountInvoices",
                          meta: {
                            breadcrumb: 'invoices'
                          },
                        },
                    ]
                },

                // OUR BRANDS
                {
                    path: '/customer/our-brands',
                    component: OurBrands.Base,
                    redirect: '/customer/our-brands/overview',
                    meta: {
                        breadcrumb: 'our-brands',
                        requiresAuth: true,
                        customerAuth: true
                    },
                    children: [
                        {
                            path: 'overview',
                            component: OurBrands.Overview,
                            name: "OurBrandsOverview",
                            meta: {
                                breadcrumb: 'our-brands overview'
                            },
                        }
                    ]
                },

                // DOWNLOADS
                {
                    path: '/customer/downloads',
                    component: Downloads.Base,
                    redirect: '/customer/downloads/overview',
                    meta: {
                        breadcrumb: 'downloads',
                        requiresAuth: true,
                        customerAuth: true
                    },
                    children: [
                        {
                            path: 'overview',
                            component: Downloads.Overview,
                            name: "DownloadsOverview",
                            meta: {
                                breadcrumb: 'downloads overview'
                            },
                        }
                    ]
                },

                // SALESMAN
                {
                    path: '/salesman',
                    component: SalesmanZone,
                    meta: {
                        requiresAuth: true,
                        salesmanAuth: true
                    }
                },
                {
                    path: '/salesman/account',
                    component: SalesmanAccount.Base,
                    redirect: '/salesman/account/edit',
                    meta: {
                        breadcrumb: 'account',
                        requiresAuth: true,
                        salesmanAuth: true
                    },
                    children: [
                        {
                            path: 'edit',
                            component: SalesmanAccount.Edit,
                            name: "SalesmanAccountEdit",
                            meta: {
                                breadcrumb: 'edit'
                            },
                        }
                    ]
                },
                {
                    path: '/salesman/pre-orders',
                    component: SalesmanPreOrders.Base,
                    meta: {
                        requiresAuth: true,
                        salesmanAuth: true
                    },
                    redirect: '/salesman/pre-orders/overview',
                    children: [
                        {
                            path: 'overview',
                            component: SalesmanPreOrders.Index,
                            name: "SalesmanPreOrdersOverview",
                            meta: {
                                breadcrumb: 'overzicht'
                            },
                        },
                        {
                            path: 'create',
                            component: SalesmanPreOrders.Create,
                            name: "SalesmanPreOrdersCreate",
                            meta: {
                                breadcrumb: 'nieuwe pre-order'
                            },
                        },
                        {
                            path: 'edit/:id',
                            component: SalesmanPreOrders.Edit,
                            name: "SalesmanPreOrdersEdit",
                            meta: {
                                breadcrumb: 'Edit'
                            },
                            props: true
                        }
                    ]
                },
                {
                    path: '/salesman/customer-list',
                    name: "CustomerListOverview",
                    component: CustomerList.Base,
                    meta: {
                        requiresAuth: true,
                        salesmanAuth: true
                    }
                },
                {
                    path: '/salesman/customer-list/customer/:id',
                    name: "CustomerListView",
                    component: CustomerList.View,
                    meta: {
                        requiresAuth: true,
                        salesmanAuth: true
                    }
                },
                {
                    path: '/salesman/users',
                    name: 'CustomerUsers',
                    component: CustomerList.Users,
                    meta: {
                        requiresAuth: true,
                        salesmanAuth: true
                    }
                },

                // ADMIN
                {
                    path: '/admin',
                    component: AdminZone,
                    name: "AdminZone",
                    meta: {
                        requiresAuth: true,
                        adminAuth: true,
                        salesmanAuth: true,
                    }
                },
                {
                    path: '/admin/reports',
                    name: 'PreOrderReport',
                    component: PreOrderReport,
                    meta: { requiresAuth: true }
                },
                {
                    path: '/admin/pre-orders',
                    component: AdminPreOrders.Base,
                    redirect: '/admin/pre-orders/beschikbare-fiches',
                    meta: {
                        breadcrumb: 'pre-orders',
                        requiresAuth: true,
                        adminAuth: true,
                        salesmanAuth: true,
                    },
                    children: [
                        {
                            path: 'beschikbare-fiches',
                            component: AdminPreOrders.AvailableFiches,
                            name: "Fiche Overview",
                            meta: {
                                breadcrumb: 'beschikbare fiches'
                            },
                        },
                        {
                            path: 'customer-preorders',
                            component: AdminPreOrders.CustomerPreOrders,
                            name: "AdminCustomerPreOrders",
                            meta: {
                                breadcrumb: 'pre-orders klanten'
                            }
                        },
                        {
                            path: 'preorder-processing',
                            component: AdminPreOrders.PreOrderProcessing,
                            name: "AdminPreOrderProcessing",
                            meta: {
                                breadcrumb: 'pre-order verwerking'
                            }
                        },
                        {
                            path: 'create',
                            component: AdminPreOrders.Create,
                            meta: {
                                breadcrumb: 'create'
                            }
                        },
                        {
                            path: 'edit/:id',
                            component: AdminPreOrders.Edit,
                            name: "AdminPreOrdersEdit",
                            meta: {
                                breadcrumb: 'edit'
                            },
                            props: true
                        }
                    ]
                },
                {
                    path: '/admin/users',
                    component: AdminAccountUsers,
                    name: "AdminAccountUsers",
                    meta: {
                        breadcrumb: 'users'
                    },
                },
                {
                    path: '/admin/editUser',
                    component: AdminAccountEditUser,
                    name: "AdminAccountEditUser",
                    meta: {
                        breadcrumb: 'edit'
                    },
                },
                {
                    path: '/admin/notifications',
                    component: Notifications.Base,
                    redirect: '/admin/notifications/list',
                    meta: {
                        breadcrumb: 'notifications',
                        requiresAuth: true,
                        adminAuth: true,
                    },
                    children: [
                        {
                            path: 'list',
                            component: Notifications.Overview,
                            name: "NotificationOverview",
                            meta: {
                                breadcrumb: 'overzicht'
                            }
                        },
                        {
                            path: 'create',
                            component: Notifications.Create,
                            meta: {
                                breadcrumb: 'create'
                            }
                        },
                        {
                            path: 'edit/:id',
                            component:  Notifications.Edit,
                            name: "NotificationsEdit",
                            meta: {
                                breadcrumb: 'edit'
                            },
                            props: true
                        }
                    ]
                },
                {
                    path: '/admin/banners',
                    component: Banners.Base,
                    redirect: '/admin/banners/list',
                    meta: {
                        breadcrumb: 'banners',
                        requiresAuth: true,
                        adminAuth: true,
                    },
                    children: [
                        {
                            path: 'list',
                            component: Banners.Overview,
                            name: "BannerOverview",
                            meta: {
                                breadcrumb: 'overzicht'
                            }
                        },
                        {
                            path: 'create',
                            component: Banners.Create,
                            meta: {
                                breadcrumb: 'create'
                            }
                        },
                        {
                            path: 'edit/:id',
                            component:  Banners.Edit,
                            name: "BannersEdit",
                            meta: {
                                breadcrumb: 'edit'
                            },
                            props: true
                        }
                    ]
                },
                {
                    path: '/admin/branches',
                    component: Branches.Base,
                    redirect: '/admin/branches/list',
                    meta: {
                        breadcrumb: 'branches',
                        requiresAuth: true,
                        adminAuth: true,
                    },
                    children: [
                        {
                            path: 'list',
                            component: Branches.Overview,
                            name: "BranchesOverview",
                            meta: {
                                breadcrumb: 'overzicht'
                            }
                        },
                        {
                            path: 'edit/:id',
                            component:  Branches.Edit,
                            name: "BranchesEdit",
                            meta: {
                                breadcrumb: 'edit'
                            },
                            props: true
                        }
                    ]
                },
                {
                    path: '/admin/coupons',
                    component: Coupons.Base,
                    redirect: '/admin/coupons/list',
                    meta: {
                        breadcrumb: 'coupons',
                        requiresAuth: true,
                        adminAuth: true,
                    },
                    children: [
                        {
                            path: 'list',
                            component: Coupons.Overview,
                            name: "CouponsOverview",
                            meta: {
                                breadcrumb: 'overzicht'
                            }
                        },
                        {
                            path: 'create',
                            component: Coupons.Create,
                            meta: {
                                breadcrumb: 'create'
                            }
                        },
                        {
                            path: 'edit/:id',
                            component:  Coupons.Edit,
                            name: "CouponsEdit",
                            meta: {
                                breadcrumb: 'edit'
                            },
                            props: true
                        }
                    ]
                },
                {
                    path: '/admin/countries',
                    component: Coupons.Base,
                    redirect: '/admin/countries/list',
                    meta: {
                        breadcrumb: 'countries',
                        requiresAuth: true,
                        adminAuth: true,
                    },
                    children: [
                        {
                            path: 'list',
                            component: Countries.Overview,
                            name: "CountriesOverview",
                            meta: {
                                breadcrumb: 'overzicht'
                            }
                        },
                        {
                            path: 'edit/:id',
                            component:  Countries.Edit,
                            name: "CountriesEdit",
                            meta: {
                                breadcrumb: 'edit'
                            },
                            props: true
                        }
                    ]
                },
                {
                    path: '/admin/sizeCharts',
                    component: SizeCharts.Base,
                    redirect: '/admin/sizeCharts/list',
                    meta: {
                        breadcrumb: 'sizeCharts',
                        requiresAuth: true,
                        adminAuth: true,
                    },
                    children: [
                        {
                            path: 'list',
                            component: SizeCharts.Overview,
                            name: "SizeChartOverview",
                            meta: {
                                breadcrumb: 'overzicht'
                            }
                        },
                        {
                            path: 'create',
                            component: SizeCharts.Create,
                            meta: {
                                breadcrumb: 'create'
                            }
                        },
                        {
                            path: 'edit/:id',
                            component:  SizeCharts.Edit,
                            name: "SizeChartEdit",
                            meta: {
                                breadcrumb: 'edit'
                            },
                            props: true
                        }
                    ]
                }
            ]
        }

    ],
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition || to.path === from.path) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})

router.beforeEach((to, from, next) => {
    // This will redirect all traffic that doesn't have a language set in the url
    let urlLang = window.location.pathname.split('/')[1];

    if (!['en', 'fr', 'nl'].includes(urlLang) && to.fullPath) {
        window.location = window.location.origin + '/' + window.app.config.locale + to.fullPath.replace(/\/([a-zA-Z0-9]{0,})/i, '');
    }

    // Set User check access from router and store
    let userCannotAccess = () => {
        return to.matched.some(record => record.meta.adminAuth) && !store.getters.isAdmin ||
               to.matched.some(record => record.meta.salesmanAuth) && (!store.getters.isAdmin && !store.getters.isSalesman) || //admin has access to salesman pages
               to.matched.some(record => record.meta.customerAuth) && !store.getters.isCustomer && !store.getters.isPersoneel && !store.getters.isMarketing
    }

    // Check isLoggedIn and if userCanAccess
    if (to.matched.some(record => record.meta.requiresAuth) && !store.getters.isLoggedIn) {
        // Prevent empty redir loops
        if (to.fullPath.trim() === '/') {
            next({ path: '/login' });
        } else {
            next({ path: '/login', query: { redirect: to.fullPath } });
        }
    } else if (userCannotAccess()) {
        // Redirect to Home page when user does not have access to the target page
        next({path: '/'});
    } else if (to.path === '/login' && store.getters.isLoggedIn) {
        // Redirect to Home page when user is already logged in
        next({ path: '/' })
    } else {
        next();
    }

});

router.afterEach((to, from) => {

    if(store.getters.isCustomer || store.getters.isPersoneel || store.getters.isMarketing){
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'Customer',
            'klant': store.getters.userInfo.customerName,
            'email': store.getters.userInfo.userName
        });

        try{
            window.triggerGTM(window, document, 'script', 'dataLayer', 'GTM-PB6XD25');
        } catch(e){

        }
    }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js